import { render, staticRenderFns } from "./IndexPageRecommendSection.vue?vue&type=template&id=105e88d0&"
import script from "./IndexPageRecommendSection.vue?vue&type=script&lang=js&"
export * from "./IndexPageRecommendSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports